import React, { useState } from 'react'
import { Box, Button, CircularProgress, Dialog, DialogContent, DialogActions, Typography, TextField } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { useDataProvider, Loading, useTranslate } from 'react-admin'
import TransferList from '../CustomizedUIs/TransferList'
import IconRadiusButton from '../CustomizedUIs/IconRadiusButton'
import { Close } from '@material-ui/icons'
import colors from '../CustomizedUIs/Colors'
import CustomPoper from '../CustomizedUIs/CustomPoper'
import { red, pink } from '@material-ui/core/colors';
import CloseButton from '../CustomizedUIs/CloseButton'

const bgColorError = pink['50'];
const textColorError = red['700'];

const useStyles = makeStyles(theme => ({
    input: {
        backgroundColor: 'white',
        borderRadius: '2px',
        "&:hover": {
            backgroundColor: 'white'
        }
    },
    underline: {
        '&::before': {
            borderBottom: '1px solid black'
        },
        '&:hover:before': {
            borderBottom: '1px solid black'
        }
    },
    underlineNotValue: {
        '&::before': {
            borderBottom: '1px solid' + colors.lightBlue['200']
        },
        '&:hover:before': {
            borderBottom: '1px solid' + colors.lightBlue['200']
        }
    },
    focuses: {
        backgroundColor: 'white !important'
    },
    dialogPaper: {
        padding: 24,
        backgroundColor: theme.palette.background.default
    }
}));




const UpdatePopup = ({ setData, getList, setShowSnackbar, data, openDialog, onClose }) => {
    const dataProvider = useDataProvider()
    const translate = useTranslate()
    const [loadingButton, setLoadingButton] = useState(false)
    const [loadingPage, setLoadingPage] = useState(false)
    const [channels, setChannels] = React.useState(null)
    const [channelsAssign, setChannelsAssign] = React.useState(null)
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [openPoper, setOpenPopper] = React.useState(false);
    const [errorSubmit, setErrorSubmit] = React.useState("");
    const [textValue, setTextValue] = React.useState({
        name: '',
        externalCode: ''
    })
    const [error, setError] = useState({
        name: { status: true, message: '' },
        externalCode: { status: true, message: '' }
    })
    const classes = useStyles()


    const onChangTextValue = (event, name) => {
        setTextValue({ ...textValue, [name]: event.target.value })
        if (event.target.value.length === 0)
            setError({ ...error, [name]: { status: true, message: 'required' } })
        else
            setError({ ...error, [name]: { status: false, message: '' } })
    }


    const handleAddChannel = () => {
        // setChannelsAssign(channelsAssign.concat(right))
        // setRight([])
    }

    const handleClickOpenPoper = (event) => {
        setAnchorEl(event.currentTarget);
        setOpenPopper(true);
    };

    const handleClosePoper = () => {
        setOpenPopper(false);
    };


    const getListChannel = (assigns) => {
        if (assigns === null) {
            setLoadingPage(true)
            assigns = []
        }
        dataProvider('GET_LIST', "channel", {
            filter: {
            },
            pagination: {
                page: 1,
                perPage: -1
            },
            sort: { field: 'createdAt', order: 'ASC' },
        }).then(({ data, total }) => {
            // var temps = data.filter(value => assigns.findIndex(element => element.id === value.id) < 0)
            setChannels(data)
            setLoadingPage(false)
        }).catch(error => {
            setLoadingPage(false)
        });
    }

    const onCreate = () => {
        setLoadingButton(true)
        var Ids = []
        channelsAssign.forEach(value => Ids.push(value.id))
        dataProvider('CREATE', "channels/creategroup", {
            data: {
                name: textValue.name,
                externalCode: textValue.externalCode,
                channels: Ids
            }
        })
            .then((response) => {
                // let temps = data.slice()
                // temps.unshift(response.data)
                // setData(temps)
                onClose()
                getList()
                setLoadingButton(false)
                setShowSnackbar({
                    status: true,
                    name: response.data.name,
                    message: translate(`pos.categories.createFolder.success`)
                })
                setTimeout(() => {
                    setShowSnackbar({
                        name: '',
                        message: '',
                        status: false
                    })
                }, 6000);
            })
            .catch(error => {
                if (error.message === 'exist')
                    setErrorSubmit('Name exist')
                setLoadingButton(false)
            })
    }

    const onSave = () => {
        setLoadingButton(true)
        var Ids = []
        channelsAssign.forEach(value => Ids.push(value.id))
        dataProvider('UPDATE', "channels/editgroup", {
            id: openDialog.data.id,
            data: {
                name: textValue.name,
                externalCode: textValue.externalCode,
                channels: Ids
            }
        })
            .then((response) => {
                // let temps = data.slice()
                // let index = temps.findIndex(e => e.id === openDialog.data.id)
                // console.log(index)
                // temps[index] = response.data
                // setData(temps)
                getList()
                onClose()
                setLoadingButton(false)
                setShowSnackbar({
                    status: true,
                    name: response.data.name,
                    message: translate(`pos.categories.editFolder.success`)
                })
                setTimeout(() => {
                    setShowSnackbar({
                        name: '',
                        message: '',
                        status: false
                    })
                }, 6000);
            })
            .catch(error => {
                if (error.message === 'exist')
                    setErrorSubmit('Name exist')
                setLoadingButton(false)
            })
    }

    const getChannelAssign = () => {
        setLoadingPage(true)

        dataProvider('GET_ONE', `channels/findbygroup`, {
            id: openDialog.data.id
        }).then(({ data }) => {
            setChannelsAssign(data)
            getListChannel(data)
        }).catch(error => {
            if (error.message === 'exist')
                setErrorSubmit('Name exist')
            setLoadingPage(false)
        });
    }

    React.useEffect(() => {
        if (!openDialog.data) {
            setTextValue({
                name: '',
                externalCode: ''
            })
            setError({
                name: { status: true, message: '' },
                externalCode: { status: true, message: '' }
            })
            setErrorSubmit('')
            setChannelsAssign([])
            getListChannel(null)
        }
        else {
            setErrorSubmit('')
            setTextValue({
                name: openDialog.data.name,
                externalCode: openDialog.data.externalCode
            })
            setError({
                name: { status: false, message: '' },
                externalCode: { status: false, message: '' }
            })
            getChannelAssign()
        }

    }, [openDialog])
    return (
        <Dialog scroll="paper" open={openDialog.status} classes={{
            paper: classes.dialogPaper
        }}>
            <Box>
                <Box display='flex' justifyContent='flex-end' alignContent='center'>
                    <Typography style={{ margin: 'auto 8px auto 0' }} variant='subtitle2'>{translate(`pos.common.close`)}</Typography>
                     <CloseButton onClick={onClose} />
                </Box>
                <Box ml={3}>
                    <Typography variant='h5'>{
                        !openDialog.data ? translate(`pos.channels.createGroup`) : translate(`pos.channels.editGroup`)
                    }</Typography>
                    {
                        openDialog.data &&
                        <Typography variant='subtitle2'>{
                            openDialog.data.name
                        }</Typography>
                    }
                </Box>

            </Box>
            <DialogContent dividers={false}>
                {
                    errorSubmit != "" && (
                        <Box borderRadius='6px' my={1} bgcolor={bgColorError} py={1}>
                            <Typography className={classes.TextValue} style={{ color: textColorError, margin: '1em' }}>{errorSubmit}</Typography>
                        </Box>
                    )
                }
                <Box
                    borderRadius={4}
                    bgcolor='#F9FBFC'
                    border={1}
                    p={1}
                    mt={3}
                    borderColor={colors.lightBlue['200']}>
                    <Box my={2} display='flex' justifyContent='center'>
                        <TextField
                            required
                            style={{ width: 500 }}
                            variant="filled"
                            error={error.name.status && error.name.message !== ''}
                            helperText={error.name.message}
                            value={textValue.name}
                            label='Name'
                            onBlur={(event) => onChangTextValue(event, 'name')}
                            onChange={(event) => onChangTextValue(event, 'name')}
                            InputProps={{
                                endAdornment:
                                    <CustomPoper
                                        open={openPoper}
                                        anchorEl={anchorEl}
                                        handleClick={handleClickOpenPoper}
                                        handleClose={handleClosePoper}
                                        title={translate(`pos.channels.groupNameTitle`)}
                                        content={translate(`pos.channels.groupName`)}
                                        icon={<b>?</b>}
                                    />,
                                className: classes.input,
                                classes: {
                                    underline: textValue.name !== '' ? classes.underline : classes.underlineNotValue,
                                    focused: classes.focuses
                                }
                            }}
                        />
                    </Box>
                    <Box my={2} display='flex' justifyContent='center'>
                        <TextField
                            required
                            variant="filled"
                            style={{ width: 500 }}
                            label={translate(`pos.channels.externalCodeTitle`)}
                            error={error.externalCode.status && error.externalCode.message !== ''}
                            helperText={error.externalCode.message}
                            value={textValue.externalCode}
                            onBlur={(event) => onChangTextValue(event, 'externalCode')}
                            onChange={(event) => onChangTextValue(event, 'externalCode')}
                            InputProps={{
                                endAdornment:
                                    <CustomPoper
                                        open={openPoper}
                                        anchorEl={anchorEl}
                                        handleClick={handleClickOpenPoper}
                                        handleClose={handleClosePoper}
                                        title={translate(`pos.channels.externalCodeTitle`)}
                                        content={translate(`pos.channels.externalCode`)}
                                        icon={<b>?</b>}
                                    />,
                                className: classes.input,
                                classes: {
                                    underline: textValue.externalCode !== '' ? classes.underline : classes.underlineNotValue,
                                    focused: classes.focuses
                                }
                            }}
                        />
                    </Box>
                </Box>

                <Box mt={3} >
                    <Typography variant='h6' style={{ marginBottom: 8 }}>{translate(`pos.channels.name`)}</Typography>
                    {
                        loadingPage ? <Loading /> : (
                            <TransferList
                                hiddenButton={true}
                                setLeft={setChannels}
                                left={channels}
                                setRight={setChannelsAssign}
                                right={channelsAssign}
                            />
                        )
                    }

                </Box>

            </DialogContent>
            <DialogActions>
                <Box mt={1} mr={1.5} display='flex' justifyContent='flex-end' width='100%'>
                    <Button color='primary' onClick={onClose}>{translate(`pos.common.cancel`)}</Button>
                    <Button
                        disabled={error.name.status || error.externalCode.status || channelsAssign.length === 0}
                        style={{ marginLeft: 8 }}
                        variant='contained'
                        color='primary'
                        onClick={openDialog.data ? onSave : onCreate}
                    >
                        {loadingButton ? (
                            <CircularProgress
                                size={15}
                                thickness={2}
                                color='inherit'
                            />
                        ) :
                            (!openDialog.data ? translate(`pos.common.create`) : translate(`pos.common.save`))
                        }
                    </Button>
                </Box>
            </DialogActions>
        </Dialog>
    )
}

export default UpdatePopup